module.exports = __webpack_public_path__ + "img/JenniferFinley.6ae9ee1b.jpg";